import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import breakpoint from 'styled-components-breakpoint';
import { Button } from 'elc-buttons';
import { EyeIcon } from 'elc-icons';
import { ContentSpacing } from 'elc-base-theme';
import { classes } from '../../utils/Classes';

export interface IProductQuickViewButton {
    label: string;
    onQuickViewButtonClick?(): void;
    enableQuickViewShortcut?: boolean;
}

const StyledButton = styled(Button)`
    display: none;
    ${breakpoint('desktop')`
        width: 100%;
        display: inline-block;
        margin-right: ${ContentSpacing.space16};
        height: 40px;
        border: none;
        padding: 0 15px;
        cursor: pointer;

        [dir='rtl'] & {
            margin-left: ${ContentSpacing.space16};
            margin-right: 0;
        }
    `};
`;

const EyeButtonWrapper = styled.div`
    text-align: right;

    [dir='rtl'] & {
        text-align: left;
    }
`;

const StyledButtonWrapper = styled.div`
    min-height: 20px;
`;

const EyeIconButton = styled.button`
    display: inline-block;
    padding: 0;
    margin: auto;
`;

export const ProductQuickViewButton = observer((props: IProductQuickViewButton) => {
    const productQuickViewButtonWrapperClassNames = classes('product-quick-view-button-wrapper');
    const productQuickViewButtonClassNames = classes('product-quick-view-button');
    const productQuickViewIconButtonClassNames = classes('product-quick-view-icon-wrapper');
    const productQuickViewShortcutIconClassNames = classes('product-quick-view-shortcut-icon');

    if (props.enableQuickViewShortcut) {
        return (
            <EyeButtonWrapper>
                <EyeIconButton
                    className={productQuickViewIconButtonClassNames}
                    onClick={props.onQuickViewButtonClick}
                >
                    <EyeIcon className={productQuickViewShortcutIconClassNames} />
                </EyeIconButton>
            </EyeButtonWrapper>
        );
    }

    return (
        <StyledButtonWrapper className={productQuickViewButtonWrapperClassNames}>
            <StyledButton
                className={productQuickViewButtonClassNames}
                onClick={props.onQuickViewButtonClick}
            >
                {props.label}
            </StyledButton>
        </StyledButtonWrapper>
    );
});
